<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>공지사항</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>

        <div class="ml-auto p-2">
          <button type="button" class="btn mint" @click="goEdit(0)">+ 공지사항 작성</button>
        </div>

      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.title" @keyup.enter="retrieve" placeholder="제목">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>

    </div>
    <!-- 그리드 -->
    <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      @row-click="rowClickHandler">
    </stone-data-table>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M990601',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableColumns: [
        {label: 'No', align: 'left', type: 'index', width: 80},
        {label: '제목', prop: 'title', align: 'left', width: '300'},
        {label: '공개', prop: 'open_yn_name', align: 'center', width: '80'},
        {label: '작성일', prop: 'reg_dt', align: 'center', width: '100'},
        {label: '작성자', prop: 'reg_name', align: 'left', width: '100'}
      ],
      search: {
        board_type: 'NOTICE',
        title: ''
      }
    }
  },
  beforeCreate () {
  },
  created () {
    this.retrieve()
  },
  mounted () {
  },
  methods: {
    retrieve: function () {
      this.loadStoneDataTable('/board/list', this.search)
        .then(response => {
          this.tableData = response.data
        })
        .catch(() => {
        })
    },
    goEdit: function (boardSeq) {
      const param = {
        board_seq: boardSeq
      }
      this.$router.push({name: 'M990602', params: param})
    },
    rowClickHandler: function (row, event, column) {
      this.goEdit(row.board_seq)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990601.vue